export default __webpack_public_path__ + "static/media/edit.83025bb3.svg";